import { Ripple } from "@/shared/ui/Ripple";

import { TastierClient } from "@/app/TastierClient";
import { Helper } from "@/app/ui/Helper";

export class ServicesIcon {
    private $element: JQuery;
    public onClick?: { () };

    constructor() {
        this.$element = Ripple.bind(
            $('<a class="go-home-button action left" href="#"><i class="fal fa-home"></i></a>')
        ).click((e) => {
            e.preventDefault();
            if (this.onClick) {
                this.onClick();
            }
        });

        this.checkVisibility();
        TastierClient.context.onAllocationChange.add(() => this.checkVisibility(), this);
    }

    public appendTo($el: JQuery): ServicesIcon {
        this.$element.prependTo($el);

        return this;
    }

    private checkVisibility() {
        if (Helper.isSingleService()) {
            this.$element.hide();
        } else {
            this.$element.show();
        }
    }
}
